import { render, staticRenderFns } from "./linkList.vue?vue&type=template&id=63dbc8e4&"
import script from "./linkList.vue?vue&type=script&lang=js&"
export * from "./linkList.vue?vue&type=script&lang=js&"
import style0 from "./linkList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports